import { routePlanApis } from '@apis/dashboard/routePlanApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { RoutePlanQuery } from '@models/RoutePlan';

export const useRoutePlanList = createUseQuery(
  (query: RoutePlanQuery) => ['/dashboard/route-plan/', query],
  (query) => () => routePlanApis.get('/dashboard/route-plan/', { query }).then((r) => r[200]!),
);
